export type ClientLogo = {
  name: string;
  src: string;
};

export const clientLogos: ClientLogo[] = [
  { name: 'American Express', src: 'https://cdn.magicpatterns.com/uploads/aoBpV6RaMnzGS1W6r8Hkfa/Amex.svg' },
  { name: 'BCG', src: 'https://cdn.magicpatterns.com/uploads/8zetyEsfaKsGSmdbyyde7w/BCG.svg' },
  { name: 'Chase', src: 'https://cdn.magicpatterns.com/uploads/5mpT3dTtkcoKimHcQdADrc/Chase.svg' },
  { name: 'DrFirst', src: 'https://cdn.magicpatterns.com/uploads/p4SGzLMuzxmhK391pmashd/DrFirst.svg' },
  { name: 'McKinsey & Company', src: 'https://cdn.magicpatterns.com/uploads/h94SXHfMwu972b7erPsoPc/McKinsey.svg' },
  { name: 'PubMatic', src: 'https://cdn.magicpatterns.com/uploads/xa7DC2xkEsFgNLpxwWaU5Y/Pubmatic.svg' },
];
